import { LoadingOverlay, Text } from '@mantine/core'
import type useShareImageResource from './useShareImageResource'
import styles from './ShareImageMenuItem.module.css'

export default function ShareImageMenuPreview({
	preview,
}: {
	preview: ReturnType<typeof useShareImageResource>['preview']
}) {
	if (preview.url) return <img className={styles.image} src={preview.url} alt="分享图预览" />
	return (
		<div className={styles.preview} aria-busy={!preview.error}>
			<LoadingOverlay
				visible={!preview.error}
				zIndex={1}
				loaderProps={{ size: 'sm', 'aria-label': '正在生成分享图' }}
				overlayProps={{ backgroundOpacity: 0 }}
			/>
			{preview.error && (
				<Text size="xs" c="dimmed" ta="center">
					生成失败，请重新悬浮或点击重试
				</Text>
			)}
		</div>
	)
}
